import {
  Box,
  Breadcrumbs,
  Card,
  CardContent,
  Typography,
  Container,
  Rating,
} from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import { reviews } from 'utils/data/reviews';

const reviewsByMostRecent = [...reviews].sort(
  (a, b) => new Date(b.data).getTime() - new Date(a.data).getTime(),
);

const Reviews = () => (
  <Container maxWidth="md" sx={{ py: 4 }}>
    <Breadcrumbs sx={{ mb: 3 }}>
      <Link to="/" style={{ color: '#c96c1e', fontSize: '0.875rem', textDecoration: 'none' }}>
        Início
      </Link>
      <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
        Depoimentos
      </Typography>
    </Breadcrumbs>

    <Typography
      variant="body1"
      color="text.secondary"
      align="center"
      sx={{ mb: 3 }}
    >
      O que nossos assinantes dizem sobre o Clube da 42
    </Typography>

    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {reviewsByMostRecent.map(review => (
        <Card key={review.id} variant="outlined" sx={{ textAlign: 'left' }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <Rating value={review.nota} readOnly size="small" />
              <Typography variant="body2" color="text.secondary">
                {review.nota.toFixed(1).replace('.', ',')}
              </Typography>
              {review.data && (
                <Typography variant="caption" color="text.secondary">
                  • {new Date(review.data).toLocaleDateString('pt-BR')}
                </Typography>
              )}
            </Box>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 0.5 }}>
              {review.titulo}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              {review.comentario}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              — {review.nome}, {review.cidade}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>

    <Box sx={{ mt: 4, textAlign: 'center' }}>
      <Link to="/" style={{ color: 'inherit', fontSize: '0.875rem' }}>
        ← Voltar ao início
      </Link>
    </Box>
  </Container>
);

export default Reviews;
